import React from 'react'
import PropTypes from 'prop-types'
import './Modal.scss'
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator'

const Modal = ({
	id,
	style,
	title,
	body,
	primaryButtonText,
	secondaryButtonText,
	customFooter,
	onPrimaryClick,
	onSecondaryClick,
	onCloseClick,
	isLoading = false,
	changeSecondaryColor = false,
	centered = false
}) => {
	const handlePrimaryClick = () => {
		if (onPrimaryClick) {
			onPrimaryClick()
		}
	}

	const handleSecondaryClick = () => {
		if (onSecondaryClick) {
			onSecondaryClick()
		}
	}

	const modalClass = `modal-dialog ${centered ? 'modal-dialog-centered' : ''} modal-dialog-scrollable`;
	return (
		<div style={style} className='show-modal modal fade show' id={id} tabIndex='-1' role='dialog' aria-hidden='true'>
			<div className={modalClass} role='document'>
				<LoadingIndicator isLoading={isLoading}>
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">{title}</h5>
							<button
								type="button"
								className="btn-close"
								data-bs-dismiss="modal"
								aria-label="Close"
								onClick={onCloseClick}
							></button>
						</div>
						<div className="modal-body">{body}</div>
						<div className="modal-footer">
							{customFooter ? (
								customFooter
							) : (
								<>
									<button
										type="button"
										className="btn btn-primary"
										data-bs-dismiss="modal"
										onClick={handlePrimaryClick}
									>
										{primaryButtonText ? primaryButtonText : 'Ok'}
									</button>
									<button
										type="button"
										className={changeSecondaryColor ? 'btn btn-primary' : 'btn btn-secondary'}
										data-bs-dismiss="modal"
										onClick={handleSecondaryClick}
									>
										{secondaryButtonText ? secondaryButtonText : 'Cancel'}
									</button>
								</>
							)}
						</div>
					</div>

				</LoadingIndicator>
			</div>
		</div>
	)
}

Modal.propTypes = {
	id: PropTypes.string,
	style: PropTypes.object,
	title: PropTypes.string.isRequired,
	body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	primaryButtonText: PropTypes.string,
	secondaryButtonText: PropTypes.string,
	customFooter: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
	onPrimaryClick: PropTypes.func,
	onSecondaryClick: PropTypes.func,
	onCloseClick: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
	changeSecondaryColor: PropTypes.bool,
	centered: PropTypes.bool,
}

export default Modal
